import React from 'react'
import "./home.css";
import Insect1 from '../../components/assets/home/bsf-insect-1.png';
import compostImage from "../../components/assets/home/bag-design.png";
import Wwdicon1 from "../../components/assets/home/icon1.png"
import Wwdicon2 from "../../components/assets/home/icon2.png"
import Wwdicon3 from "../../components/assets/home/icon3.png"
import insectImage from "../../components/assets/home/bsf-insect-2.png";
import imageworm from "../../components/assets/home/bsf-larvae.png";
import fp1 from "../../components/assets/home/featuredproducts/chickenfeed.png"
import fp2 from "../../components/assets/home/featuredproducts/fish.png"
import fp3 from "../../components/assets/home/featuredproducts/exoticanimalfeed.png"
import fp4 from "../../components/assets/home/featuredproducts/organixmanure.png"
import fp5 from "../../components/assets/home/featuredproducts/misez.png"

import { Helmet } from 'react-helmet-async';

function home() {

  return (
    <div>
      <Helmet>
        <title>Enteeon - Revolutionizing Protein: Sustainable, Nutritious, Future-Ready!</title>
        <meta name="description" content="Enteeon is transforming waste into wealth. We pioneer sustainable farming by upcycling organic biowaste into high-quality animal feed and organic manure through the Black Soldier Fly (BSF)." />
        <meta name="keywords" content="Enteeon, sustainable protein, black soldier fly, BSF, organic manure, animal feed, eco-friendly, waste to wealth, poultry feed, fish feed, exotic animal feed" />
        <meta property="og:title" content="Enteeon - Revolutionizing Protein: Sustainable, Nutritious, Future-Ready!" />
        <meta property="og:description" content="Enteeon is transforming waste into wealth. We pioneer sustainable farming by upcycling organic biowaste into high-quality animal feed and organic manure through the Black Soldier Fly (BSF)." />
        <meta property="og:image" content="https://enteeon.com/enteeon_logo.png" />
        <meta property="og:url" content="https://enteeon.com" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Enteeon - Revolutionizing Protein: Sustainable, Nutritious, Future-Ready!" />
        <meta name="twitter:description" content="Enteeon is transforming waste into wealth. We pioneer sustainable farming by upcycling organic biowaste into high-quality animal feed and organic manure through the Black Soldier Fly (BSF)." />
        <meta name="twitter:image" content="https://enteeon.com/enteeon_logo.png" />
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Enteeon",
            "url": "https://enteeon.com",
            "logo": "https://enteeon.com/enteeon_logo.png",
            "description": "Enteeon is transforming waste into wealth. We pioneer sustainable farming by upcycling organic biowaste into high-quality animal feed and organic manure through the Black Soldier Fly (BSF).",
            "foundingDate": "2023",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9876543210",
              "contactType": "customer service"
            }
          }`}
        </script>
      </Helmet>

        {/* hero-section */}
        <section className="hero-section">
      <div className="overlay">
        <div className="container text-center">
          <h1 className="hero-title">Enteeon.</h1>
          <p className="hero-subtitle">
            Revolutionizing Protein: Sustainable, Nutritious, Future-Ready!
          </p>
          <button className="hero-button btn-">Learn How!</button>
        </div>
      </div>
    </section>

    {/* Sustainability section */}
    <section className="sustainability-section">
      <div className="container-fluid">
        <div className="row align-items-center">
          {/* Image Section */}
          <div className="col-md-2 text-center text-md-start">
            <img
              src={Insect1}
              alt="Black Soldier Fly"
              className="img-fluid insect_one"
            />
          </div>

          {/* Text Section */}
          <div className="col-md-4">
            <h2 className="sustainability-title">
              Pioneering <span>Sustainability.</span>
            </h2>
            </div>

            <div className="col-md-6">
            <p className="sustainability-description">
              Enteeon is transforming waste into wealth. We pioneer sustainable
              farming by upcycling organic biowaste into high-quality animal
              feed and organic manure through the <b>Black Soldier Fly (BSF)</b>.
              Our innovative methods contribute to environmental sustainability
              while enhancing farming productivity.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* what we do section starts here */}
    <section className="what-we-do-section">
      <div className="container text-center">
        {/* Title */}
        <h2 className="what-we-do-title">What We Do.</h2>

        {/* Description */}
        <p className="what-we-do-description">
          We harness the power of insect proteins, using the black soldier fly larvae as a 
          unique source of protein for food and feed, to revolutionize sustainable food and 
          feed production. By converting bio-waste into valuable proteins and lipids, we 
          provide an eco-friendly alternative to traditional protein sources like soy and 
          fish meal—reducing land and water consumption while protecting ecosystems.
        </p>
{/* Button */}
<button className="meet-bsf-button">Learn More</button>
  

        {/* Features Section */}
        <div className="row what-we-do-features">
           {/* Image */}
        <div className="col-md-3 col-12 what-we-do-image-container">
          <img src={compostImage} alt="Organic Compost" className="what-we-do-image" />
        </div>
          <div className="col-md-3 col-12 feature-item">
            <img src={Wwdicon2} alt="Eco-Friendly" className="feature-icon" />
            <h4 className="feature-title">Eco-Friendly –</h4>
            <p className="feature-text">Reduces food waste & carbon footprint</p>
          </div>
          <div className="col-md-3 col-12 feature-item">
            <img src={Wwdicon3} alt="Nutrient-Rich" className="feature-icon" />
            <h4 className="feature-title">Nutrient-Rich –</h4>
            <p className="feature-text">
              High in protein, essential amino acids, and healthy fats
            </p>
          </div>
          <div className="col-md-3 col-12 feature-item">
            <img src={Wwdicon1} alt="Sustainable" className="feature-icon" />
            <h4 className="feature-title">Sustainable –</h4>
            <p className="feature-text">
              Minimal land & water usage compared to traditional sources
            </p>
          </div>
        </div>
      </div>
    </section>
    {/* what we do section ends here */}

    {/* Featured Products list starts here */}
     <section className="featured-products-section">
      <h2 className="featured-title">Featured Products.</h2>
      <div className="container-fluid">
        <div className="row justify-content-center">
          {[
            { image: fp1, title: "Poultry Feed", desc: "Boosts immunity and improves egg quality." },
            { image: fp2, title: "Fish Feed", desc: "Organic and antibiotic-free for healthier aquaculture." },
            { image: fp3, title: "Exotic Animal Feed", desc: "Perfect blend of essential nutrients for a balanced diet." },
            { image: fp4, title: "Organic Manure", desc: "Rich in nutrients, improves soil health." },
            { image: fp5, title: "Misez", desc: "India's 1st Chitosan Based Cosmetic Brand." }
          ].map((product, index) => (
            <div key={index} className="col-md-2 col-sm-6 col-12 product-card">
              <div className="product-image-container">
                <img src={product.image} alt={product.title} className="product-image" />
              </div>
              <h3 className="product-title">{product.title}</h3>
              <p className="product-description">{product.desc}</p>
            </div>
          ))}
        </div>
        <button className="view-more-btn">View More Products</button>
      </div>
    </section>
    {/* Featured Products list ends here */}

    {/* Why Choose us? starts here */}
    <section className="why-choose-us">
      <div className="container-fluid">
    <h2 className="featured-title-wgu ">Why Choose Us?</h2>
        <div className="row align-items-center">
          {/* Left Side - Dark Box */}
          <div className="col-md-5 left-section">
            <h3 className="section-title">Fastest Protein Conversion Rate:</h3>
            <p className="section-text">
              Enteeon converts bio-waste to alternative protein sources in 15 to 20 days, 
              which is four times faster than soybean feed. 1000kgs of larvae may be produced 
              in a 250 sq.ft. space.
            </p>
            <h3 className="section-title">Organic Waste Processing:</h3>
            <p className="section-text">
              Enteeon sustainably processes biowaste from local vendors such as fruit markets, 
              vegetable sellers, and meat processing plants that would otherwise be discarded 
              in dumpyards.
            </p>
          </div>

          {/* Middle Image - Positioned Absolutely */}
          <div className="col-md-2 image-container">
            <img src={insectImage} alt="Black Soldier Fly" className="insect-image" />
          </div>

          {/* Right Side - White Background */}
          <div className="col-md-5 right-section">
            <h3 className="section-title">Healing the environment:</h3>
            <p className="section-text">
              By converting biowaste into a high-protein source, we are solving several serious 
              environmental challenges – reducing carbon footprint by 80%, and completing the food 
              system chain.
            </p>
            <h3 className="section-title">Revolutionizing Feed Industry:</h3>
            <p className="section-text">
              By offering an alternate sustainable protein supply from waste materials, BSF will complete 
              the food chain system as a whole, lowering costs and improving ecological balance.
            </p>
          </div>
        </div>
      </div>
    </section>
    {/* Why Choose us? ends here */}

{/* How we are growing? starts here*/}
<section className="how-we-are-growing container">
      <h2 className="section-title-hwrg">How we are growing?</h2>
      <div className="row">
        <div className="col-md-4 growth-box">
          <h3 className="highlight">70%</h3>
          <p className="bold-text">Reduce carbon emissions by 70%,</p>
          <p>Better for the Planet</p>
        </div>
        <div className="col-md-4 growth-box">
          <h3 className="highlight">15-20 days</h3>
          <p className="bold-text">Produce sustainable feed in just 15-20 days.</p>
          <p>Efficient Solutions</p>
        </div>
        <div className="col-md-4 growth-box">
          <h3 className="highlight">Innovation</h3>
          <p className="bold-text">Bridging the gap between waste management and farming needs.</p>
          <p>Innovative Impact</p>
        </div>
      </div>
      <div className="text-center mt-4">
        <button className="discover-more">Discover More</button>
      </div>
      <img src={imageworm} alt="Black Soldier Fly Larvae" className="bg-image" />
    </section>
{/* How we are growing? ends here*/}

{/* sustainability quote starts here */}
<section className="sustainable-protein-section">
      <div className="background-image"></div>
      <div className="container text-center content-wrapper">
        <h1 className="title">
          <b>Sustainable Protein & Organic Solutions</b>
        </h1>
        <p className="subtitle">
          <b>Turning bio-waste into high-quality proteins for food and feed.</b>
        </p>
        <button className="contact-button">Contact us</button>
      </div>
    </section>
{/* sustainability quote ends here */}

{/* overall quote starts here */}
<section className="quote-section">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-10 text-center quote-container">
            <span className="quote-icon">“</span>
            <p className="quote-text">
              <b>
                Waste is a natural resource in the wrong place. <br />
                Change the context and you have usable products.
              </b>
            </p>
          </div>
        </div>
      </div>
    </section>
{/* overall quote ends here */}
    </div>
  )
}

export default home